var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#4381bf",
    stroke: "#4381bf",
    strokeWidth: 1.344,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#4381bf;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.5,24A21.51,21.51,0,0,0,24,2.5h0l7.23,7.24,4.09-4M18.14,4.17a2.11,2.11,0,0,0-1.47.61L4.78,16.67a2.07,2.07,0,0,0,0,2.93L28.4,43.22a2.07,2.07,0,0,0,2.93,0L43.22,31.33a2.08,2.08,0,0,0,0-2.94L19.61,4.78A2.11,2.11,0,0,0,18.14,4.17ZM2.5,24A21.51,21.51,0,0,0,24,45.5l-7.23-7.24-4.09,4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.91,
    y1: 21.73,
    x2: 21.73,
    y2: 6.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 26.27,
    y1: 41.09,
    x2: 41.09,
    y2: 26.26
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurn);
export default __webpack_public_path__ + "static/media/turn.28267a035c6c00de082afd6abc9261f7.svg";
export { ForwardRef as ReactComponent };